// extracted by mini-css-extract-plugin
export default {"Text":"---------packages-corgi-x-src-components-Text-Text-module__Text"};